import { RouteObject } from 'react-router';
import { Navigate } from 'react-router-dom';

import SidebarLayout from 'src/layouts/SidebarLayout';

import { StandingsPage, ResultsPage, NewPicksPage } from 'src/pages';
import LoginPage from 'src/pages/Auth/LoginPage';
// import RegisterPage from 'src/pages/Auth/RegisterPage';
import AuthRoute from 'src/components/Auth/AuthRoute';
import LogoutPage from 'src/pages/Auth/LogoutPage';
import ForgotPage from 'src/pages/Auth/ForgotPage';
import ResetPage from 'src/pages/Auth/ResetPage';
import AdminRoute from './components/Auth/AdminRoute';
import AdminPage from './pages/Admin/AdminPage';
import RulesPage from './pages/Rules/RulesPage';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SidebarLayout />,
    children: [
      {
        path: '/*',
        element: (
          <AuthRoute>
            <Navigate to='/' />
          </AuthRoute>
        ),
      },
      {
        path: '/',
        element: (
          <AuthRoute>
            <StandingsPage />
          </AuthRoute>
        ),
      },
      {
        path: 'picks',
        element: (
          <AuthRoute>
            <NewPicksPage />
          </AuthRoute>
        ),
      },
      {
        path: 'results',
        element: (
          <AuthRoute>
            <ResultsPage />
          </AuthRoute>
        ),
      },
      {
        path: 'rules',
        element: (
          <AuthRoute>
            <RulesPage />
          </AuthRoute>
        ),
      },
      // {
      //   path: 'register', // TODO: disable this path when playoffs start
      //   element: <RegisterPage />,
      // },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'logout',
        element: (
          <AuthRoute>
            <LogoutPage />
          </AuthRoute>
        ),
      },
      {
        path: 'forgot',
        element: <ForgotPage />,
      },
      {
        path: 'reset',
        element: <ResetPage />,
      },
      {
        path: 'hokage',
        element: (
          <AdminRoute>
            <AdminPage />
          </AdminRoute>
        ),
      },
    ],
  },
];

export default routes;
